export default {
  default: () => import("/Users/fbonin/IdeaProjects/lotto-qc/github/org-rd-fullstack-springboot-nuxt/src/frontend/layouts/default.vue").then(m => m.default || m)
}